import { deleteProperty } from "@/services/helpers";

export const brandAdded = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const reset = (state, payload) => {
  state.list = {};
  state.loaded = false;
};

export const replaceBrand = (state, payload) => {
  state.list[payload.id] = payload;
};

export const brandRemoved = (state, payload) => {
  state.list = deleteProperty(state.list, payload.toString());
};

export const brandRestored = (state, payload) => {
  const updatedBrand = { ...state.list[payload], deleted_at: false };
  state.list = { ...state.list, [payload]: updatedBrand };
};

export const initBrands = (state, payload) => {
  state.list = payload;
  state.loaded = true;
};
